<template>
    <div id="app">
        <b-navbar toggleable="lg" class="navbar">
            <b-navbar-brand class="brand" :to="{ name: 'Home' }">Budapest Escort Girl</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse" class="toggle"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{name: 'Home'}">Home</b-nav-item>
                    <b-nav-item :to="{name: 'FAQ'}">FAQ</b-nav-item>
                    <b-nav-item :to="{name: 'Hotels'}">Hotels</b-nav-item>
                    <b-nav-item :to="{name: 'Advices'}">Advices</b-nav-item>
                    <b-nav-item :to="{name: 'JoinUs'}">Join Us</b-nav-item>
                    <b-nav-item :to="{name: 'Blog'}">Blog</b-nav-item>
                    <b-nav-item :to="{name: 'Banner'}">Banner</b-nav-item>
                    <b-nav-item :to="{name: 'Contact'}">Contact</b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <router-view/>

        <!-- Footer -->
        <footer class="page-footer font-small indigo text-white mt-5">

            <!-- Footer Links -->
            <div class="container text-center text-md-left">

                <!-- Grid row -->
                <div class="row">

                    <!-- Grid column -->
                    <div class="col-md-3 mx-auto">

                        <!-- Links -->
                        <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Links</h5>

                        <ul class="list-unstyled">
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'escort-girl-budapest'}}">escort girl budapest</router-link>
                            </li>
                            <li>
                              <router-link :to="{ name: 'Escort', params: {'slug': 'escort-girl-hungary'}}">escort girl hungary</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'girls-escort-budapest'}}">girls escort budapest</router-link>
                            </li>
                        </ul>

                    </div>
                    <!-- Grid column -->

                    <hr class="clearfix w-100 d-md-none">

                    <!-- Grid column -->
                    <div class="col-md-3 mx-auto">

                        <!-- Links -->
                        <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Links</h5>

                        <ul class="list-unstyled">
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'girls-escort-hungary'}}">girls escort hungary</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'hungarian-girls'}}">hungarian girls</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'girl-partner-budapest'}}">girl partner budapest</router-link>
                            </li>
                        </ul>

                    </div>
                    <!-- Grid column -->

                    <hr class="clearfix w-100 d-md-none">

                    <!-- Grid column -->
                    <div class="col-md-3 mx-auto">

                        <!-- Links -->
                        <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Links</h5>

                        <ul class="list-unstyled">
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'girl-partner-hungary'}}">girl partner hungary</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'babes-budapest'}}">babes budapest</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'babes-hungary'}}">babes hungary</router-link>
                            </li>
                        </ul>

                    </div>
                    <!-- Grid column -->

                    <hr class="clearfix w-100 d-md-none">

                    <!-- Grid column -->
                    <div class="col-md-3 mx-auto">

                        <!-- Links -->
                        <h5 class="font-weight-bold text-uppercase mt-3 mb-4">Links</h5>

                        <ul class="list-unstyled">
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'top-escort-budapest'}}">top escort budapest</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'top-escort-hungary'}}">top escort hungary</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'Escort', params: {'slug': 'top-escort-girl-budapest'}}">top escort girl budapest</router-link>
                            </li>
                        </ul>

                    </div>
                    <!-- Grid column -->

                </div>
                <!-- Grid row -->

            </div>
            <!-- Footer Links -->

            <!-- Copyright -->
            <div class="footer-copyright text-center py-3">© {{new Date().getFullYear()}} Copyright:
                <a :href="`https://${domain}`">{{ domain }}</a>
            </div>
            <!-- Copyright -->

        </footer>
        <!-- Footer -->
    </div>
</template>


<script>
    export default {
        metaInfo: {
            titleTemplate: '%s - Budapest Escort Girls',
            meta: [
                { name: 'description', content: 'Hungarian, escort girls service is waiting for you to make your stay in Budapest pleasant.' }
            ],
            htmlAttrs: {
                lang: 'en',
                amp: 'true'
            }
        },
        data() {
            return {
                'domain': process.env.VUE_APP_DOMAIN
            }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

</style>
